// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#room-edit[data-v-bb13e0fc]{max-width:880px;margin-left:auto;margin-right:auto}#room-edit .cancel-btn[data-v-bb13e0fc],#room-edit .register-btn[data-v-bb13e0fc]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
